import {
  Anchor as MantineAnchor,
  type AnchorProps as MantineAnchorProps,
} from "@mantine/core";
import type { CoreComponentProps, PolymorphicProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type AnchorProps = CoreComponentProps<MantineAnchorProps, 'a'> &
  PolymorphicProps;

export function Anchor({ testId, view = "all", ...rest }: AnchorProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineAnchor data-testid={testId} {...(rest as MantineAnchorProps)} />;
}
